var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-47",
    "data-name": "50_Kids_Icons-47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M0,40.247A40,40,0,1,1,40.248,80,40,40,0,0,1,0,40.247Z",
    transform: "translate(0 0)",
    fill: "#3d2a3d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5062",
    "data-name": "Group 5062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5002",
    "data-name": "Group 5002",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4986",
    "data-name": "Group 4986",
    transform: "translate(32.62 30.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4978",
    "data-name": "Group 4978",
    transform: "translate(0 13.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4972",
    "data-name": "Group 4972",
    transform: "translate(2.129 9.819)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_398",
    "data-name": "Ellipse 398",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.812, 7.641)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_399",
    "data-name": "Ellipse 399",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 4.183)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4973",
    "data-name": "Group 4973",
    transform: "translate(6.778 10.993)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_400",
    "data-name": "Ellipse 400",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.784, 7.37)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_401",
    "data-name": "Ellipse 401",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 4.035)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4974",
    "data-name": "Group 4974",
    transform: "translate(11.648 10.177)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_402",
    "data-name": "Ellipse 402",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.755, 7.099)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_403",
    "data-name": "Ellipse 403",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.887)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4975",
    "data-name": "Group 4975",
    transform: "translate(16.287 7.791)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_404",
    "data-name": "Ellipse 404",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.726, 6.828)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_405",
    "data-name": "Ellipse 405",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.738)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4976",
    "data-name": "Group 4976",
    transform: "translate(20.247 4.258)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_406",
    "data-name": "Ellipse 406",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.697, 6.558)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_407",
    "data-name": "Ellipse 407",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.59)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4977",
    "data-name": "Group 4977",
    transform: "translate(23.077)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_408",
    "data-name": "Ellipse 408",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.668, 6.287)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_409",
    "data-name": "Ellipse 409",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.442)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_410",
    "data-name": "Ellipse 410",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 16.567)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4985",
    "data-name": "Group 4985",
    transform: "translate(13.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4979",
    "data-name": "Group 4979",
    transform: "translate(9.821 2.128)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_411",
    "data-name": "Ellipse 411",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 3.458, 6.121)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_412",
    "data-name": "Ellipse 412",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 5.309)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4980",
    "data-name": "Group 4980",
    transform: "translate(10.994 6.778)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_413",
    "data-name": "Ellipse 413",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 3.335, 5.904)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_414",
    "data-name": "Ellipse 414",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 5.121)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4981",
    "data-name": "Group 4981",
    transform: "translate(10.177 11.648)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_415",
    "data-name": "Ellipse 415",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 3.212, 5.687)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_416",
    "data-name": "Ellipse 416",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 4.932)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4982",
    "data-name": "Group 4982",
    transform: "translate(7.792 16.287)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_417",
    "data-name": "Ellipse 417",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 3.09, 5.47)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_418",
    "data-name": "Ellipse 418",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 4.744)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4983",
    "data-name": "Group 4983",
    transform: "translate(4.259 20.246)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_419",
    "data-name": "Ellipse 419",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 2.967, 5.253)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 4.556)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4984",
    "data-name": "Group 4984",
    transform: "translate(0 23.076)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_421",
    "data-name": "Ellipse 421",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 2.845, 5.036)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_422",
    "data-name": "Ellipse 422",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 4.368)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_423",
    "data-name": "Ellipse 423",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 12.385, 5.309)",
    fill: "#fceeb3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5001",
    "data-name": "Group 5001",
    transform: "translate(10.76 30.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4993",
    "data-name": "Group 4993",
    transform: "translate(5.55 13.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4987",
    "data-name": "Group 4987",
    transform: "translate(19.227 9.821)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_424",
    "data-name": "Ellipse 424",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 8.008)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_425",
    "data-name": "Ellipse 425",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.812, 4.55)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4988",
    "data-name": "Group 4988",
    transform: "translate(14.921 10.994)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_426",
    "data-name": "Ellipse 426",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 7.724)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_427",
    "data-name": "Ellipse 427",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.784, 4.389)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4989",
    "data-name": "Group 4989",
    transform: "translate(10.396 10.177)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_428",
    "data-name": "Ellipse 428",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 7.44)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_429",
    "data-name": "Ellipse 429",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.755, 4.228)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4990",
    "data-name": "Group 4990",
    transform: "translate(6.101 7.792)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_430",
    "data-name": "Ellipse 430",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 7.156)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_431",
    "data-name": "Ellipse 431",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.726, 4.066)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4991",
    "data-name": "Group 4991",
    transform: "translate(2.486 4.259)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_432",
    "data-name": "Ellipse 432",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 6.872)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_433",
    "data-name": "Ellipse 433",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.697, 3.905)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4992",
    "data-name": "Group 4992"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_434",
    "data-name": "Ellipse 434",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 6.589)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_435",
    "data-name": "Ellipse 435",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.669, 3.744)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_436",
    "data-name": "Ellipse 436",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 22.168, 16.935)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5000",
    "data-name": "Group 5000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4994",
    "data-name": "Group 4994",
    transform: "translate(0.742 2.129)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_437",
    "data-name": "Ellipse 437",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 4.398)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_438",
    "data-name": "Ellipse 438",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 3.458, 3.586)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4995",
    "data-name": "Group 4995",
    transform: "translate(0 6.778)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_439",
    "data-name": "Ellipse 439",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 4.242)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_440",
    "data-name": "Ellipse 440",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 3.335, 3.458)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4996",
    "data-name": "Group 4996",
    transform: "translate(1.249 11.648)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_441",
    "data-name": "Ellipse 441",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 4.086)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_442",
    "data-name": "Ellipse 442",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 3.213, 3.331)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4997",
    "data-name": "Group 4997",
    transform: "translate(4.066 16.287)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_443",
    "data-name": "Ellipse 443",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.93)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_444",
    "data-name": "Ellipse 444",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 3.09, 3.204)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4998",
    "data-name": "Group 4998",
    transform: "translate(8.031 20.247)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_445",
    "data-name": "Ellipse 445",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.774)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_446",
    "data-name": "Ellipse 446",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 2.967, 3.077)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4999",
    "data-name": "Group 4999",
    transform: "translate(12.722 23.077)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_447",
    "data-name": "Ellipse 447",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.618)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_448",
    "data-name": "Ellipse 448",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 2.845, 2.95)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_449",
    "data-name": "Ellipse 449",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 1.635, 3.586)",
    fill: "#fceeb3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5017",
    "data-name": "Group 5017",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5009",
    "data-name": "Group 5009",
    transform: "translate(30.391 42.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5003",
    "data-name": "Group 5003",
    transform: "translate(21.091)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_450",
    "data-name": "Ellipse 450",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "translate(1.87 3.815) rotate(-6.76)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_451",
    "data-name": "Ellipse 451",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "translate(0 0.796) rotate(-6.76)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5004",
    "data-name": "Group 5004",
    transform: "translate(18.766 4.013)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_452",
    "data-name": "Ellipse 452",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "translate(1.804 3.68) rotate(-6.76)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_453",
    "data-name": "Ellipse 453",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "translate(0 0.767) rotate(-6.76)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5005",
    "data-name": "Group 5005",
    transform: "translate(14.879 6.773)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_454",
    "data-name": "Ellipse 454",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "translate(1.738 3.544) rotate(-6.76)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_455",
    "data-name": "Ellipse 455",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "translate(0 0.739) rotate(-6.76)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5006",
    "data-name": "Group 5006",
    transform: "translate(10.044 8.262)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_456",
    "data-name": "Ellipse 456",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "translate(1.672 3.409) rotate(-6.76)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_457",
    "data-name": "Ellipse 457",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "translate(0 0.711) rotate(-6.76)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5007",
    "data-name": "Group 5007",
    transform: "translate(4.88 8.459)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_458",
    "data-name": "Ellipse 458",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "translate(1.605 3.274) rotate(-6.76)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_459",
    "data-name": "Ellipse 459",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "translate(0 0.683) rotate(-6.76)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5008",
    "data-name": "Group 5008",
    transform: "translate(0 7.344)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_460",
    "data-name": "Ellipse 460",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "translate(1.539 3.139) rotate(-6.76)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_461",
    "data-name": "Ellipse 461",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "translate(0 0.655) rotate(-6.76)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_462",
    "data-name": "Ellipse 462",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "translate(24.41 1.104) rotate(-6.76)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5016",
    "data-name": "Group 5016",
    transform: "translate(17.799 42.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5010",
    "data-name": "Group 5010",
    transform: "translate(1.448)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_463",
    "data-name": "Ellipse 463",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "translate(0 8.772) rotate(-83.24)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_464",
    "data-name": "Ellipse 464",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "translate(1.871 5.753) rotate(-83.24)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5011",
    "data-name": "Group 5011",
    transform: "translate(4.101 4.013)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_465",
    "data-name": "Ellipse 465",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "translate(0 8.461) rotate(-83.24)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_466",
    "data-name": "Ellipse 466",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "translate(1.804 5.549) rotate(-83.24)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5012",
    "data-name": "Group 5012",
    transform: "translate(8.317 6.774)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_467",
    "data-name": "Ellipse 467",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "translate(0 8.15) rotate(-83.24)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_468",
    "data-name": "Ellipse 468",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "translate(1.738 5.345) rotate(-83.24)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5013",
    "data-name": "Group 5013",
    transform: "translate(13.48 8.263)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_469",
    "data-name": "Ellipse 469",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "translate(0 7.84) rotate(-83.24)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_470",
    "data-name": "Ellipse 470",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "translate(1.672 5.141) rotate(-83.24)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5014",
    "data-name": "Group 5014",
    transform: "translate(18.973 8.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_471",
    "data-name": "Ellipse 471",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "translate(0 7.529) rotate(-83.24)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_472",
    "data-name": "Ellipse 472",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "translate(1.605 4.937) rotate(-83.24)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5015",
    "data-name": "Group 5015",
    transform: "translate(24.181 7.345)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_473",
    "data-name": "Ellipse 473",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "translate(0 7.218) rotate(-83.24)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_474",
    "data-name": "Ellipse 474",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "translate(1.539 4.734) rotate(-83.24)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_475",
    "data-name": "Ellipse 475",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "translate(0 6.061) rotate(-83.24)",
    fill: "#fceeb3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5018",
    "data-name": "Group 5018",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_476",
    "data-name": "Ellipse 476",
    cx: 22.844,
    cy: 16.662,
    rx: 22.844,
    ry: 16.662,
    transform: "translate(17.156 22.326)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5019",
    "data-name": "Group 5019",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M115.961,399.234l-.009-.144c0-8.781-3.287-17.288-7.3-18.908L91.559,373.3a22.645,22.645,0,0,0-14.6-.019L59.62,380.2c-4.017,1.608-7.3,10.106-7.3,18.886l-.009.144h63.654Z",
    transform: "translate(-44.134 -313.94)",
    fill: "#bd6442"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5020",
    "data-name": "Group 5020",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M224.15,250.8a6.825,6.825,0,0,1-6.825,6.825H216.5a6.825,6.825,0,0,1-6.825-6.825V233.22a6.825,6.825,0,0,1,6.825-6.825h.828a6.825,6.825,0,0,1,6.825,6.825Z",
    transform: "translate(-176.912 -191.021)",
    fill: "#bd6442"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5022",
    "data-name": "Group 5022",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5021",
    "data-name": "Group 5021",
    transform: "translate(26.099 14.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M194.835,119.859a13.9,13.9,0,0,1-13.9,13.9h0a13.9,13.9,0,0,1-13.9-13.9V108.3a13.9,13.9,0,0,1,13.9-13.9h0a13.9,13.9,0,0,1,13.9,13.9v11.562Z",
    transform: "translate(-167.033 -94.396)",
    fill: "#d67f5e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5023",
    "data-name": "Group 5023",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_477",
    "data-name": "Ellipse 477",
    cx: 1.698,
    cy: 1.698,
    r: 1.698,
    transform: "translate(32.67 38.487)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_478",
    "data-name": "Ellipse 478",
    cx: 1.698,
    cy: 1.698,
    r: 1.698,
    transform: "translate(43.933 38.487)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5024",
    "data-name": "Group 5024",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M162.891,88.282c-9.523,0-17.242,8.367-17.242,18.689a19.809,19.809,0,0,0,2.338,9.4l.565-4.794a11.025,11.025,0,0,1,10.949-9.734h6.778a11.025,11.025,0,0,1,10.95,9.732l.567,4.8a19.812,19.812,0,0,0,2.338-9.4C180.134,96.649,172.414,88.282,162.891,88.282Z",
    transform: "translate(-122.891 -74.488)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5025",
    "data-name": "Group 5025",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M243.3,272.071a2.616,2.616,0,0,1-5.106.591,2.769,2.769,0,0,0-.125.78,2.8,2.8,0,1,0,5.6,0A2.765,2.765,0,0,0,243.3,272.071Z",
    transform: "translate(-200.873 -229.56)",
    fill: "#bd6442"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5026",
    "data-name": "Group 5026",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M115.952,413.291c0-8.781-3.287-17.288-7.3-18.908l-13.591-5.475a12,12,0,0,1-21.828.058L59.62,394.4c-4.017,1.608-7.3,10.106-7.3,18.886l-.009.144h63.654Z",
    transform: "translate(-44.134 -328.141)",
    fill: "#78bede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5027",
    "data-name": "Group 5027",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M226.93,295.282a5.359,5.359,0,0,1-7.119,0c-1.351-1.272-3.392.761-2.037,2.037a8.3,8.3,0,0,0,11.193,0c1.355-1.276-.686-3.309-2.037-2.037Z",
    transform: "translate(-183.371 -248.804)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5058",
    "data-name": "Group 5058",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5042",
    "data-name": "Group 5042",
    transform: "translate(10.76 10.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5034",
    "data-name": "Group 5034",
    transform: "translate(5.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5028",
    "data-name": "Group 5028",
    transform: "translate(19.229 0.742)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_479",
    "data-name": "Ellipse 479",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 4.183)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_480",
    "data-name": "Ellipse 480",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.812, 7.641)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5029",
    "data-name": "Group 5029",
    transform: "translate(14.923)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_481",
    "data-name": "Ellipse 481",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 4.035)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_482",
    "data-name": "Ellipse 482",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.784, 7.37)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5030",
    "data-name": "Group 5030",
    transform: "translate(10.397 1.249)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_483",
    "data-name": "Ellipse 483",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.887)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_484",
    "data-name": "Ellipse 484",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.755, 7.099)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5031",
    "data-name": "Group 5031",
    transform: "translate(6.102 4.066)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_485",
    "data-name": "Ellipse 485",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.738)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_486",
    "data-name": "Ellipse 486",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.726, 6.828)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5032",
    "data-name": "Group 5032",
    transform: "translate(2.486 8.031)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_487",
    "data-name": "Ellipse 487",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.59)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_488",
    "data-name": "Ellipse 488",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.697, 6.558)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5033",
    "data-name": "Group 5033",
    transform: "translate(0 12.721)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_489",
    "data-name": "Ellipse 489",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.442)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_490",
    "data-name": "Ellipse 490",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.668, 6.287)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_491",
    "data-name": "Ellipse 491",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 22.169, 5.818)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5041",
    "data-name": "Group 5041",
    transform: "translate(0 5.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5035",
    "data-name": "Group 5035",
    transform: "translate(0.741 19.227)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_492",
    "data-name": "Ellipse 492",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 5.309)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_493",
    "data-name": "Ellipse 493",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 3.457, 6.121)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5036",
    "data-name": "Group 5036",
    transform: "translate(0 14.922)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_494",
    "data-name": "Ellipse 494",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 5.121)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_495",
    "data-name": "Ellipse 495",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 3.335, 5.904)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5037",
    "data-name": "Group 5037",
    transform: "translate(1.249 10.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_496",
    "data-name": "Ellipse 496",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 4.932)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_497",
    "data-name": "Ellipse 497",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 3.212, 5.687)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5038",
    "data-name": "Group 5038",
    transform: "translate(4.067 6.101)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_498",
    "data-name": "Ellipse 498",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 4.744)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_499",
    "data-name": "Ellipse 499",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 3.09, 5.47)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5039",
    "data-name": "Group 5039",
    transform: "translate(8.032 2.486)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_500",
    "data-name": "Ellipse 500",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 4.556)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_501",
    "data-name": "Ellipse 501",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 2.967, 5.253)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5040",
    "data-name": "Group 5040",
    transform: "translate(12.723)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_502",
    "data-name": "Ellipse 502",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 4.368)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_503",
    "data-name": "Ellipse 503",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 2.845, 5.036)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_504",
    "data-name": "Ellipse 504",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 1.635, 27.477)",
    fill: "#fceeb3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5057",
    "data-name": "Group 5057",
    transform: "translate(32.622 10.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5049",
    "data-name": "Group 5049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5043",
    "data-name": "Group 5043",
    transform: "translate(2.128 0.741)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_505",
    "data-name": "Ellipse 505",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.813, 4.55)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_506",
    "data-name": "Ellipse 506",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 8.008)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5044",
    "data-name": "Group 5044",
    transform: "translate(6.778)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_507",
    "data-name": "Ellipse 507",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.784, 4.389)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_508",
    "data-name": "Ellipse 508",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 7.724)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5045",
    "data-name": "Group 5045",
    transform: "translate(11.647 1.249)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_509",
    "data-name": "Ellipse 509",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.755, 4.228)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_510",
    "data-name": "Ellipse 510",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 7.44)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5046",
    "data-name": "Group 5046",
    transform: "translate(16.287 4.067)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_511",
    "data-name": "Ellipse 511",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.726, 4.066)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_512",
    "data-name": "Ellipse 512",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 7.156)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5047",
    "data-name": "Group 5047",
    transform: "translate(20.246 8.032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_513",
    "data-name": "Ellipse 513",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.697, 3.905)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_514",
    "data-name": "Ellipse 514",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 6.872)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5048",
    "data-name": "Group 5048",
    transform: "translate(23.076 12.723)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_515",
    "data-name": "Ellipse 515",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.668, 3.744)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_516",
    "data-name": "Ellipse 516",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 6.589)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_517",
    "data-name": "Ellipse 517",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 6.185)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5056",
    "data-name": "Group 5056",
    transform: "translate(13.86 5.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5050",
    "data-name": "Group 5050",
    transform: "translate(9.819 19.229)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_518",
    "data-name": "Ellipse 518",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 3.458, 3.586)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_519",
    "data-name": "Ellipse 519",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 4.398)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5051",
    "data-name": "Group 5051",
    transform: "translate(10.993 14.923)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_520",
    "data-name": "Ellipse 520",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 3.335, 3.458)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_521",
    "data-name": "Ellipse 521",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 4.242)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5052",
    "data-name": "Group 5052",
    transform: "translate(10.177 10.397)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_522",
    "data-name": "Ellipse 522",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 3.213, 3.331)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_523",
    "data-name": "Ellipse 523",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 4.086)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5053",
    "data-name": "Group 5053",
    transform: "translate(7.791 6.102)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_524",
    "data-name": "Ellipse 524",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 3.09, 3.204)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_525",
    "data-name": "Ellipse 525",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.93)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5054",
    "data-name": "Group 5054",
    transform: "translate(4.259 2.486)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_526",
    "data-name": "Ellipse 526",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 2.967, 3.077)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_527",
    "data-name": "Ellipse 527",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.774)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5055",
    "data-name": "Group 5055"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_528",
    "data-name": "Ellipse 528",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 2.845, 2.95)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_529",
    "data-name": "Ellipse 529",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.618)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_530",
    "data-name": "Ellipse 530",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 12.384, 25.755)",
    fill: "#fceeb3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5061",
    "data-name": "Group 5061",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5059",
    "data-name": "Group 5059",
    transform: "translate(31.738 35.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M204.312,228.275a2.882,2.882,0,0,1,2.748-.626.686.686,0,0,0,.365-1.322,4.3,4.3,0,0,0-4.082.978c-.656.6.317,1.563.97.97Z",
    transform: "translate(-203.124 -226.165)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5060",
    "data-name": "Group 5060",
    transform: "translate(43.477 35.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M282.821,227.306a4.3,4.3,0,0,0-4.082-.978.686.686,0,0,0,.365,1.322,2.882,2.882,0,0,1,2.748.626c.653.593,1.626-.374.97-.97Z",
    transform: "translate(-278.255 -226.165)",
    fill: "#fceeb3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar8);
export default __webpack_public_path__ + "static/media/avatar8.742a6971b05191d6856518ae0c9489a7.svg";
export { ForwardRef as ReactComponent };